import moment from "moment";
import React, { useState, useEffect, useContext } from "react";
import Utilities from "../../../../../../../services/commonservice/utilities";
import Table2 from "../../../../../../templates/components/Table2";
import APIResponse from "../../../../../../templates/components/APIResponse";
import { store } from "../../../../../../../context/StateProvider";
import TreatmentPlanService from "../../../../../../../services/api/treatment-plan.service";
import TreatmentPlanEdit from "../../../../treatment-plan/treatment-plan-edit/TreatmentPlanEdit";
import ModalBox from "../../../../../../templates/components/ModalBox";
import DimLoader from "../../../../../../templates/components/DimLoader";
import { useGetLocationProviderServices } from "../../../../../../../services/cache/CacheService";
import ProductService from "../../../../../../../services/api/product.service";
const TreatmentPlanList = (props) => {
  const [treatmentPlans, setTreatmentPlans] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [isLoader_Delete, setIsLoader_Delete] = useState(false);

  const [apiResponse, setApiResponse] = useState()
  const globalStateAndDispatch = useContext(store)
  const state = globalStateAndDispatch.state
  const [locationId, setLocationId] = useState(state.practiceLocationId)
  const [selectedTreatmentPlan, setSelectedTreatmentPlan] = useState()
  const [showTreatmentPlanEdit, setShowTreatmentPlanEdit] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [toastOnSuccess, setToastOnSuccess] = useState(false)
  const [doctorList, setDoctorList] = useState()
  const stateDoctorList = useGetLocationProviderServices();
  const [productList, setProductList] = useState([])
  const onSuccess = (message) => {
    if (apiResponse?.data?.data) {
      setTreatmentPlans(apiResponse.data.data);
    }
    if (props.refresh) {
      props.refresh()
    }
    if (props.onClose) {
      props.onClose()
    }
    if (props.exitHandler) {
      props.exitHandler()
    }
  }

  useEffect(() => {
    if (stateDoctorList) {
      setDoctorList(stateDoctorList)
    }
  }, [stateDoctorList]);

  useEffect(() => {
    treatmentPlansLookup()
    productLookup()
  }, []);

  useEffect(() => {
    if (locationId) {
      productLookup()
    }
  }, [locationId]);

  const productLookup = () => {
    const reqObj = {
      practiceLocationId: locationId,
      includePracticeItems: 'yes',
      isActive: true
    };
    ProductService.productLookup(reqObj)
      .then(res => {
        if (res) {
          setProductList(extractItems(res, 1))
        }
      }
      )
  }
  const extractItems = (results, itemType) => {
    let items = [];
    if (Array.isArray(results)) {
      items = results.filter(result => { return result?.itemType == itemType && (result?.practiceLocationId == "" || result?.practiceLocationId == locationId) });
    }
    if (!Array.isArray(items)) {
      items = [];
    }
    return items;
  }

  const deleteTreatmentPlan = (treatmentPlan) => {
    setIsLoader_Delete(true);
    TreatmentPlanService.deleteTreatmentPlan(treatmentPlan.treatmentPlanId)
      .then(res => {
        setToastOnSuccess(true)
        setApiResponse(res)
        treatmentPlansLookup();
      }).catch(error => {
        setApiResponse(error)
      })
      .finally(() => {
        setIsLoader_Delete(false)
      });
  }

  const treatmentPlansLookup = () => {
    setTreatmentPlans()
    setIsLoader(true);
    let reqObj = {
      SortField: "modifiedOn",
      Asc: false,
      StartRow: 0,
      PatientIds: props.patient?.id
    };
    TreatmentPlanService.getAllTreatmentPlan(reqObj).then((res) => {
      setToastOnSuccess(false)
      setApiResponse(res)
    }).catch(error => {
      setApiResponse(error)
    })
      .finally(() => {
        setIsLoader(false)
      });
  };

  const tableColumns = [
    {
      id: "subData",
      Header: "",
      accessor: (row) => ""
    },
    {
      id: "treatmentPlan",
      Header: "Treatment Plan",
      accessor: (row) => row.treatmentPlan
    },
    {
      id: "doctorId",
      Header: "Provider",
      accessor: (row) => {
        let selectedDoctor = doctorList?.find((obj) => obj.id === row.doctorId)
        return selectedDoctor ? (selectedDoctor.firstName + ' ' + selectedDoctor.lastName) : ""
      }
    },
    {
      id: "createdOn",
      Header: "Created On",
      accessor: (cell) => moment(cell.createdOn).format("MM/DD/YYYY h:mm a"),
    },
    {
      id: "action",
      Header: "Action",
      textAlign: 'center',
      disableSortBy: true,
      accessor: (cell, i) => {
        return (
          <div className='d-flex justify-content-center'>
            <button className="p-0 ps-1 btn btn-primary" title="edit" onClick={e => { e.preventDefault(); setSelectedTreatmentPlan(cell); return setShowTreatmentPlanEdit(true) }}><i className="icon pencil" /></button>
            <button className="p-0 ps-1 btn btn-primary ms-1" title="delete" onClick={e => { e.preventDefault(); setSelectedTreatmentPlan(cell); return setDeleteModal(true) }}><i className="icon trash" /></button>
          </div>
        )
      }
    }
  ];


  const tableSubColumns = [
    {
      id: "doctorId",
      Header: "Provider",
      accessor: (row) => {
        let selectedDoctor = doctorList?.find((obj) => obj.id === row.doctorId)
        return selectedDoctor ? (selectedDoctor.firstName + ' ' + selectedDoctor.lastName) : ""
      }
    },
    {
      id: "practiceServiceTypeId",
      Header: "Service",
      accessor: (row) => {
        let selectedProviderService = doctorList?.find((obj) => obj.id === row.doctorId)?.services.find((ser) => ser.practiceServiceTypeId === row.practiceServiceTypeId)?.practiceServiceType
        return selectedProviderService ? selectedProviderService : row.practiceServiceTypeId
      }
    },
    {
      id: "itemId",
      Header: "Product",
      accessor: row => {
        let selectedProduct = productList?.find(obj => obj.id === row.itemId)
        return selectedProduct ? selectedProduct.name : row.itemId
      }
    },
    {
      id: "datePlanned",
      Header: "Date Planned",
      accessor: (row) =>row.datePlanned ? moment(row.datePlanned).format("MM-DD-YYYY") : null,
    },
    {
      id: "quantity",
      Header: "Quantity",
      accessor: (row) => row.quantity
    },
  ];
  const subDataAccessor = (row) => {
    return (
      <Table2
        data={row.treatmentPlanDetail}
        columns={tableSubColumns}
      />
    );
  };
  return (
    <div title="TreatmentPlans" className="py-3">
      {isLoader_Delete ?
        <DimLoader loadMessage="Processing.." /> : null}
      <Table2
        data={treatmentPlans}
        columns={tableColumns}
        loading={isLoader}
        subDataAccessor={subDataAccessor}
        subDataId="subData" //column to add expand icon
      />
      <ModalBox open={showTreatmentPlanEdit} onClose={() => { setShowTreatmentPlanEdit(false) }} title="Edit Treatment Plans">
        <TreatmentPlanEdit productList={productList} initialData={selectedTreatmentPlan} patient={props.patient} refresh={() => treatmentPlansLookup()} onClose={() => { setShowTreatmentPlanEdit(false) }} isModal />
      </ModalBox>
      <ModalBox open={deleteModal} onClose={() => { setDeleteModal(false) }} title="Delete Treatment Plan">
        <div className='row d-flex align-items-center justify-content-between'>
          <div className='col'>
            Are you sure you want to permanently delete this treatment plan?
          </div>
          <div className='col-auto'>
            <button className='btn btn-secondary' onClick={e => { e.preventDefault(); return setDeleteModal(false) }}>No</button>
            <button className='btn btn-primary ms-3' onClick={e => { e.preventDefault(); deleteTreatmentPlan(selectedTreatmentPlan); return setDeleteModal(false) }}>Yes</button>
          </div>
        </div>
      </ModalBox>
      <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={toastOnSuccess} />
    </div>
  );
};

export default TreatmentPlanList;
